import { withNamespace } from "components/Form/FormikControls";

import { CommentColId } from "constants/columnDefinitions/comments";
import { EmailColId } from "constants/columnDefinitions/email";
import { SaleLotNamespaces } from "constants/saleLots";

const XERO = {
  CONTACT_NAME: "billingItem.xeroBusinessName",
  EMAIL_ADDRESS: "billingItem.contact.email",

  // Root from selector.
  PO_ADDRESS_LINE1: "po.line1",
  PO_ADDRESS_LINE2: "po.line2",
  PO_ADDRESS_LINE3: "po.line3",
  PO_ADDRESS_LINE4: "po.line4",
  PO_CITY: "po.city",
  PO_REGION: "po.region",
  PO_POSTAL_CODE: "po.postalCode",
  PO_COUNTRY: "po.country",

  // Root from selector
  SA_ADDRESS_LINE1: "sa.line1",
  SA_ADDRESS_LINE2: "sa.line2",
  SA_ADDRESS_LINE3: "sa.line3",
  SA_ADDRESS_LINE4: "sa.line4",
  SA_CITY: "sa.city",
  SA_REGION: "sa.region",
  SA_POSTAL_CODE: "sa.postalCode",
  SA_COUNTRY: "sa.country",

  // Root from selector
  INVOICE_NUMBER: "invoiceNumber",

  REFERENCE: "billingItem.reference",
  INVOICE_DATE: "billingItem.invoiceDate",
  DUE_DATE: "billingItem.dueDate",
  PLANNED_DATE: "billingItem.plannedDate",
  TOTAL: "billingItem.total",
  TAX_TOTAL: "billingItem.taxTotal",

  INVOICE_AMOUNT_PAID: "billingItem.invoiceAmountPaid",
  INVOICE_AMOUNT_DUE: "billingItem.invoiceAmountDue",
  INVENTORY_ITEM_CODE: "billingItem.inventoryItemCode",
  DESCRIPTION: "billingItem.description",
  QUANTITY: "billingItem.quantity",
  UNIT_AMOUNT: "billingItem.unitAmount",
  DISCOUNT: "billingItem.discount",
  LINE_AMOUNT: "billingItem.lineAmount",
  ACCOUNT_CODE: "billingItem.accountCode",
  TAX_TYPE: "billingItem.taxType",
  TAX_AMOUNT: "billingItem.taxAmount",
  TRACKING_NAME_1: "billingItem.tracking1.name",
  TRACKING_OPTION_1: "billingItem.tracking1.option",
  TRACKING_NAME_2: "billingItem.tracking2.name",
  TRACKING_OPTION_2: "billingItem.tracking2.option",
  CURRENCY: "billingItem.currency",
  TYPE: "billingItem.type",
  BRANDING_THEME: "billingItem.type", // this is the a rename of type, but we want both columns
};

const ConsignmentColId = {
  VENDOR_NUM: "vendorNumber",
  VENDOR_NAME: "vendor_name",
  BUSINESS_DISPLAY_NAME: "vendor.publicDisplayName",
  AGENCY_NAME: "livestockAgency.name",
  AGENCY_VENDOR_NUM: "consignment.agencyVendorNumber",
  AGENT_RELATIONSHIP: "vendor.relationships",
  TRANSIT_INSURANCE_FOR_SALES: "719890c2-59d2-4b44-85e1-aee9fcc40026",
  TRANSIT_INSURANCE_FOR_PURCHASES: "3ce66cbd-4301-4d12-b22d-78135253def2",
  VENDOR_CONSIGNMENT_PIC: "vendor_property.PIC",
  CONSIGNED_FROM: "consignedFrom",
  BRANCH: "branchName",
  BRANDS: "d88fd149-c438-475f-b18d-49bcb2b5c511",
  RECEIVE_REF: "receiving_reference",
  RECEIVE_PEN: "receiving_pen",
  RECEIVAL_PENS: "receivalPens",
  RECEIVAL_LOTS_HEAD_COUNT: "receivalLotsHeadCount",
  RECEIVAL_LOTS_SCAN_COUNT: "receivalLotsScanCount",
  RECEIVAL_LOTS: "receivalLots",
  QUANTITY: "quantity",
  SCANNED_COUNT: "scannedCount",
  SCANNED_PERCENTAGE: "scannedPercentage",
  CONSIGNMENT_SCANNED_COUNT: "consignmentScannedCount",
  DRAFT_HC: "drafted",
  NVD_HC: "quantity_NVD",
  CONSIGNMENT_DIFF: "quantity_diff",
  NVD_RECEIVED: "isNVDAttached",
  NVD_ID: "NVD",
  NVD_VERSION: "035e44b7-3a43-4950-956a-bdf87d58d14e",
  ADDITIONAL_PICS: "880d7edd-b73a-4e54-a714-49eeaeebba83",
  NVD_QUESTION_1: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
  NVD_QUESTION_2: "b2c3d4e5-f6g7-8901-bcde-f23456789012",
  NVD_QUESTION_3: "c3d4e5f6-g7h8-9012-cdef-345678901234",
  NVD_QUESTION_4: "d4e5f6g7-h8i9-0123-defg-456789012345",
  NVD_QUESTION_5: "e5f6g7h8-i9j0-1234-efgh-567890123456",
  NVD_QUESTION_6: "f6g7h8i9-j0k1-2345-fghi-678901234567",
  NVD_QUESTION_7: "g7h8i9j0-k1l2-3456-ghij-789012345678",
  NVD_QUESTION_8: "h8i9j0k1-l2m3-4567-hijk-890123456789",
  NVD_QUESTION_9: "i9j0k1l2-m3n4-5678-ijkl-901234567890",
  ATTACHMENTS: "attachments",
  PIC_PROGRAMS: "nlisPrograms",
  LPA_STATUS: "lpaStatus",
  VENDOR_PIC_LPA_NUMBER: "vendor_property.lpaNumber",
  VENDOR_PIC_MSA_NUMBER: "vendor_property.msaNumber",
  DELIVERY_DATE: "carrierCharge.deliveryDate",
  ABN: "vendor.abn",
  ABN_CHECK: "f401995e-b38f-4e10-8ec1-5e489e5e8904",
  ABN_WARNINGS: "c768bbcc-8e7c-4840-8529-ad15be0044c2",
  GST_STATUS: "vendor.isGSTRegistered",
  IS_HOBBY_FARMER: "vendor.isHobbyFarmer",
  CARRIER: "carrierCharge.carrier",
  HAS_ARRIVED: "hasArrived",
  CREATED: "created",
  LAST_MODIFIED: "last_modified",
  VENDOR_SHORT_CODE: "vendor_short_code",
  VENDOR_SHORT_CODE_SALEYARD: "vendor.shortCodeSaleyard",
  NOMINATION: "nomination",
  NOMINATION_CONSIGNING_DEPLOYMENT: "nominationConsigningDeployment.name",
  NOMINATION_DETAILS: "nominationDetails",
  NOMINATION_VENDOR: "nominationVendor.name",
  NOMINATION_HAS_ARRIVED: "nomination.hasArrived",
  VENDOR_SPLITS: "313a743d-46d3-418a-ba01-eef109f9d8bb",
  TOTAL_VALUE: "38056a70-0083-41e0-aa69-978d6066b5ef",
  UNIT_VALUE: "732eace3-62fe-44c6-9d22-bc05dd13a7f0",
  SOLD_QUANTITY: "f0d00c1f-bafc-47fd-a830-57fde2e412b2",
  WARNING: "037ec826-a25e-4e8f-8a71-221d80aebbdb",
  NEVER_EVER_ELIGIBILITY_STATUS: "bbd21ec0-816c-4b88-a275-08aa1f4ea201",
  VENDOR_EMAIL_RECIPIENTS: "e3f1d1b4-7c2b-4c18-9a6d-4a1e9d7a5c3f",
};

export const RuleBookColId = {
  NAME: "64f7b297-7028-4269-8940-8ec28655d134",
};

export const IssuerColId = {
  ISSUER: "0f06f55c-e545-40d0-8034-5366d0363d68",
  ISSUER_NAME: "1ecae355-5e2f-4e5f-8c61-edb17ce0e150",
  ISSUER_XERO_INTEGRATION_BUSINESS: "b9007180-80bc-4e01-a999-9b08e4966c59",
};

export const RecipientColId = {
  RECIPIENT: "8ca6c430-0dfa-425a-b133-3aa0b3b919f9",
  RECIPIENT_NAME: "aa1bc1ad-b63f-4fc8-9c7e-832c4bb57258",
  RECIPIENT_XERO_INTEGRATION_BUSINESS: "d99e7d2d-ce5c-4d61-a904-375e35a3063f",
};

export const BillingTagsColId = {
  TAGS: "55c89f62-6628-4a0d-bb50-9b607414c1f9",
  TAG_NAMES: "47be2fc9-98c2-4914-82db-e3a7308eff50",
};

export const LivestockSaleColId = {
  ASSIGNEES: "a7e1c2b4-9f3d-4c5a-8b6e-2d1f0a9c7e34",
  COMMENTS: "7c4adc97-3901-4841-a798-d4375218227c",
  DATE: "3f3daabb-87a4-4e38-aeaa-c08dc15046c3",
  MANAGERS: "f2b8d4c6-1a3e-4f7b-9c0d-5e6a8b2c1d49",
  SALE_CODE: "9d214518-2fd0-47f2-9549-93a2cefcb7a9",
  SALE_SUB_TYPE: "7fc57e14-aae3-4a18-b49c-f7e2814ef9e4",
  SALE_TYPE: "62216b32-894d-43b8-a8ba-24be574b9fa3",
  SALEYARD: "b480b5c4-3cdd-48e4-9268-249d81b6d495",
  SPECIES_NAME: "620394f7-a5a6-4f03-8691-14df594363be",
  STATUS: "4308aec9-8a92-4ae8-aed5-b406a9f18727",
  TITLE: "livestockSale.title",
};

export const NominationDetailColId = {
  BREED: "fc93bd08-2eb6-4eeb-a3b7-a2fbe5c359a3",
  SEX: "2d1fc06d-1f32-41be-8659-7baf32a4b511",
  AGE: "b4a8041a-31c2-4d6f-ab91-4b3cffd6082d",
  WEIGHT: "487b2129-2e03-4ed5-bf90-b77bfee9e252",
  NOTES: "612b7489-5f68-4012-9e6d-ad9486a453f4",
  NOMINATION_TERM: "0a66df7f-5e11-4f38-b7a9-eac39577c33d",
};

const CattleDraftingAttributesColId = {
  ACCREDITATION_EU: "7a3715df-433a-4b6b-8327-d37775aae09d",
  ACCREDITATION_GRASS_FED: "24410a56-20e5-4b40-8102-2655f04bbb88",
  ACCREDITATION_PTIC: "d69abb35-fabc-44f6-b423-9332a5abc84c",
  ACCREDITATION_PCAS: "a6e7a04d-939a-4b4a-8ec8-e9687d11a8f2",
  ACCREDITATION_ANTIBIOTIC_FREE: "89c54b5e-f1be-4bbb-bf24-4ef23b2d7974",
  ACCREDITATION_JBAS: "2de1d310-3c6d-47f5-a84f-647ab959189f",
  ACCREDITATION_PTE: "0f8acd37-96dd-4ffa-a9ae-48b301e8413f",
  ACCREDITATION_ORGANIC: "254a9104-b53b-40e3-b360-33e6ba584c85",
  ACCREDITATION_STATION_MATED: "fb97b417-9403-4a19-aa00-66c4c2f76c58",
  ACCREDITATION_NOT_STATION_MATED: "d64b68db-0262-4dd7-9947-03442f7dec53",
  ACCREDITATION_BACKGROUNDED: "febb6552-4234-4c64-8304-4ab90b10491b",
  ACCREDITATION_FEEDER: "b65d5c50-9bc4-46e3-ab6a-c6d12822a85c",
  ACCREDITATION_GRAIN_FED_DAYS: "770747ee-9972-4425-8778-8d69deb65190",
};

const SheepDraftingAttributesColId = {
  ANIMAL_HEALTH_STATEMENT_OVERRIDE: "c16b3f02-bfff-4796-8421-bab7501a9524",
  SIX_IN_ONE: "bd563807-95b3-4a39-b225-5f63d416ba53",
  DRENCHED: "ed24f325-73bd-422a-bbdc-95ca58ec70c4",
  OJD_VAC: "a5ebf1c9-2bd9-41cb-9cea-24ddd9073100",
  GUDAIR_APPROVED: "748c8cd1-0548-463c-8487-05b9792f042d",
  B12_VAC: "3e00b153-c496-421f-a807-3b082cf8550e",
  BACKLINE: "ec29820c-1eb0-4f44-a1e0-04213d1c00c1",
  M_AND_TS: "d7641537-d5a5-49f6-9480-93b8a395f7b0",
  SA_ELIGIBLE: "8ca218a2-d71e-4a49-9bd6-0877fde658ad",
  PAIN_RELIEF: "e9872897-6515-44c3-80a6-076ce6310199",
  ACCREDITATION_ORGANIC: "4adc34ad-8490-49e6-94a5-0eaf2d636f41",
};

const DraftingAttributesColId = {
  CattleDraftingAttributes: CattleDraftingAttributesColId,
  SheepDraftingAttributes: SheepDraftingAttributesColId,
};

const TransporterColId = {
  NAME: "3409c5e9-a0bc-412c-9876-9bc0028496bc",
  SHORT_CODE_SALEYARD: "8de50728-beb9-4462-a950-dfbc9b537d73",
};

const SaleLotColId = {
  TAG_NUMBER: "draftingAttributes.tagNumber",
  ANIMAL_NAME: "draftingAttributes.animalName",
  PUBLIC_DESCRIPTION: "e9fd27e7-2b4c-422b-b2e3-2db876174d31",
  ACCOUNT_NOTE: "6b01fafe-ca8e-4f12-97ee-f8a6f1a5f2d6",
  UNIT_PRICE: "c11fa90e-ddbe-47cb-b4e4-9103d167b0db",
  PRICING_TYPE: "9c4ede2e-bd6c-400f-bbd6-556f633f5de0",
  ESTIMATED_WEIGHT_RANGE: "ecb99246-ff99-4b2f-9334-c97d98bf953e",
  ESTIMATED_DRESSING_RANGE: "fad86946-66ff-46ca-b704-4ce4b0995922",
  PEN_SCAN_LOTS: "4698f205-d84c-4b35-963f-80a84403c0f9",
  VENDOR_SPLITS: "3acc4797-b6db-4907-80df-adf601e5433d",
  WARNING: "160e2d36-6ed5-41cc-a092-73a8595e9362",
  NEVER_EVER_ACCREDITATION_STATUS: "7534711b-2b8b-4192-9e92-c37ef477a761",
  IS_WEANED: "7a6894bf-5304-4ae6-a1c4-db9bd394071d",
  EST_DENTITION: "f7e433da-4f45-46a1-9143-0a5ec7c98d99",
  BUYER_PIC: "fa2f7a6d-e4fa-42a7-97ba-3f5e576a0771",
  BUYER_SPLITS: "07f8fc57-c0d8-4cd6-8dea-39df423352d9",
  PRIVATE_SALE_VENDOR_SPLITS: "496e4bc5-732a-4357-870e-551ed17cc501",
  SALE_NAME: "0bfe5e4b-605a-441d-a719-3d6cb851424a",
  SALE_DATE: "134eb1b6-db75-4232-b9b0-aeb001f1631c",
  BREED_CODE: "2dee998d-6f87-4a28-b3b6-e48414bbcf91",
  BREED_SALEYARD_CODE: "b0f8c1d2-3e4f-4a5b-8c6d-7e8f9a0b1c2d",
  AGE_GROUP_CODE: "d719fced-fedc-4a56-b4df-53f470df11cf",
  PRODUCT_CODE: "f5e506c3-84a2-418a-9e2d-ba149169c8c6",
  PRODUCT_SALEYARD_CODE: "6edd7b58-8412-46bd-8c58-a600517970d7",
  SELLING_ORDER: "e0f3c0bc-5f06-486a-a752-1dca1607bd1b",
  CARRIER_NAME: "8b46a435-1146-441d-945c-8045fa277e91",
  CARRIER_CHARGE_INVOICE_NUMBER: "c605d7d5-b30c-4822-b19f-4e696c89e4e2",
  CARRIER_CHARGE_DELIVERY_DATE: "c48fe582-417e-446b-b5de-b5a1d09f57db",
  CARRIER_CHARGE_INVOICE_AMOUNT: "e263947f-e935-4d85-abc0-dafe78c38a36",
  CARRIER_CHARGE_DELIVERY_NOTES: "4e57453b-d8cf-4ea4-81c9-f28fbda5b129",
  IS_NOT_MOUTHED: "06952998-2910-4a19-a228-92dcfc4a4bf8",
  CATTLE_DENTITION_0: "52480af6-5a8c-4eeb-ba34-0a457db36674",
  SHEEP_DENTITION_0: "a1ef5f76-f731-4345-a105-4a49529d6380",
  DENTITION_2: "71b5d1bf-5322-42f9-b4f4-4157e0963ec7",
  DENTITION_4: "3095dfc9-f670-415d-b1a2-7170edeab290",
  DENTITION_6: "6ba3f8bf-147f-47d6-8b39-dae9be83dea7",
  DENTITION_8: "b30a3ebb-7f73-4260-9160-9ef26c2acf4a",
  DENTITION_BROKEN: "8e16d85a-0be2-43ab-9d03-daeaa1640861",
  AGE_MONTHS: "a3f7c2d1-4e8b-4a56-9c3f-1d2e5b7a8c90",
  DROP_START: "e7b1a6f5-8c2d-4e90-3a7b-5c6d9f0e2a34",
  DROP_END: "f8c2b7a6-9d3e-4f01-4b8c-6d7e0a1f3b45",
  BLOODLINE: "b4e8d3c2-5f9a-4b67-0d4e-2e3f6c8b9d01",
  X_BLOODLINE: "c5f9e4d3-6a0b-4c78-1e5f-3f4a7d9c0e12",
  VENDOR_BRED: "d6a0f5e4-7b1c-4d89-2f6a-4b5e8e0d1f23",
  FAT_SCORE_1: "e5991bfe-f96c-4f2d-9b5f-d649f2c8ce0c",
  FAT_SCORE_2: "cd079455-42eb-477f-b0c0-e97d7a9a2152",
  FAT_SCORE_3: "bba5ac4d-49a2-4674-88b1-477d131594e1",
  FAT_SCORE_4: "0ef6af4e-5dfb-4d9b-bfb7-69ce05081a60",
  FAT_SCORE_5: "563d8bdd-b7f8-4b35-a62e-099e8ca77367",
  FAT_SCORE_6: "8fbbd5ae-4d93-4be2-b103-72254a372c54",
  MUSCLE_SCORE_1: "f6ecb4d2-d7f1-4319-bed8-546a70e1a368",
  MUSCLE_SCORE_2: "744b4316-6e7f-4ca1-93fb-44f1504d9f46",
  MUSCLE_SCORE_3: "946b8b70-a58c-4f73-9259-0b4312eba6aa",
  MUSCLE_SCORE_4: "b953e558-c3fd-44b1-a542-40ee6936f4be",
  MUSCLE_SCORE_5: "8496a231-b475-404e-991b-401cf9afd792",
  HORN_POLLED: "fee7228b-1a8f-46b8-ba5c-c044f7a9d8ce",
  HORN_HORNED: "b335fb35-27f9-479f-b4f0-010c37182ec8",
  HORN_DEHORNED: "f0a2f6c1-f0fa-4c29-9191-8c9f5465dfd6",
  HORN_TIPPED: "9ae9daac-d4cd-4136-9a31-0552763d9e40",
  HORN_SCURRED: "b933b194-217f-4c22-a2d5-e48e144d3217",
  CONDITION_STORE: "d9d4e642-5cc1-4b90-8c4d-bad3dc7b6be2",
  CONDITION_FORWARD: "01154f0b-8321-4858-9c38-43908b4f4ea4",
  CONDITION_PRIME: "6ed45089-59fa-48ba-96c2-ad2d60d1b958",
  EST_CARCASS_WEIGHT: "ed6aeabe-7bbe-4cbc-a266-564996e39c4a",
  DRESSING_PERCENT: "cdaf4ad2-c3ea-45b9-93d0-87537e94c1e2",
  MIN_MASS_GRAMS: "906c2f68-a2d2-482e-a2aa-b08e086a34b1",
  MAX_MASS_GRAMS: "e359948b-4721-4308-b675-909c91df6f62",
  IS_ESTIMATED_WEIGHT: "10cbb5ab-e1cc-49cd-a2cf-0192ad1844aa",
  WEIGH_LOCATION: "9fc1b6af-55c3-4a6a-8b7a-923ba917a9d2",
  PREG_STATUS: "f031215f-3adc-4278-8f5d-beccf72e738f",
  SIL: "960ef680-b712-4124-8b79-e2e12e9ca016",
  JOINED_START: "9d801ebe-787f-4e11-96f5-0c93da690b3c",
  JOINED_END: "2e2563e5-0513-4b7a-90d9-ca23ed27f0e2",
  DEPASTURED: "d87134ea-bd4a-44aa-8400-1ee1c87052df",
  SHEARING: "8b29899d-9829-4484-b3c6-1a34ba6d400a",
  SHEARING_STATUS: "b63cdb57-72ed-4cfd-b31c-d5deef910ed9",
  FRAME_STRUCTURE: "50af64e2-4ae3-41fe-81a2-41fb207a0fc8",
  ADVANCED_BREED_1_ID: "36d5e92b-51b2-43f6-80c2-e7b03ac4afb2",
  ADVANCED_BREED_1_HD: "e6d2657e-13ac-4c24-9b81-5748bc01d126",
  ADVANCED_BREED_2_ID: "54af9534-ef26-4a69-b5ee-da0613136736",
  ADVANCED_BREED_2_HD: "0eef2932-f0ae-4f4f-aef7-160f1f2a084a",
  ADVANCED_BREED_3_ID: "52d7b9e6-fe59-4bbb-8cf5-e6cf315c5cac",
  ADVANCED_BREED_3_HD: "492b889e-f29f-4406-9085-428b4a9f0516",
  PUBLIC_FAULT_DESCRIPTION: "3420c841-f9f6-4618-ab36-ed080a8d48bc",
  PART_OF_RUN: "6319a961-af8b-483b-98a9-29f9fc3da2af",
  BY_SIRE: "917159a5-9e5b-4e9d-95c3-50cf7442575d",
  EST_LIVE_WEIGHT: "303abcf1-d7c4-4652-a613-57522984657e",
};

const TotalColId = {
  LOW_DOLLARS_HEAD: "6260a772-7dc7-4143-a837-90ba7e8d7b73",
  AVG_DOLLARS_HEAD: "46ac436e-d15f-4f3c-b2d6-326fde5fe3f9",
  HIGH_DOLLARS_HEAD: "bc45f7e5-1ccf-48a9-907c-2afbb7a85c94",
  LOW_CENTS_KG: "37d1a9a0-b480-41b5-8c2d-e86b6c19d4d5",
  AVG_CENTS_KG: "dbee910c-d780-450a-a918-8257d599670b",
  HIGH_CENTS_KG: "d302f012-e77a-46e2-a100-c472fe1e1171",
  HEAD: "7d574b20-937e-4a94-8949-fb195bf25fc8",
  CENTS: "710bfae2-1031-4bc5-a947-02d105dfe679",
};

const LoadsColId = {
  ID: "e8c3b8e2-7b1a-4e2a-9c2d-1a2b3c4d5e6f",
  LOAD_STATUS: "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d",
  DATE: "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e",
  CREATED: "c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f",
  BUYER_NAME: "d4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a",
  BUYER_WAY_NAME: "e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b",
  DELIVERY_PEN: "f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c",
  DESTINATION_PIC: "a7b8c9d0-e1f2-4a3b-4c5d-6e7f8a9b0c1d",
  LAST_MODIFIED: "3fe1df47-baa1-4c3f-b4e3-677f98a97b89",
  LIVESTOCK_SALE_ID: "b8c9d0e1-f2a3-4b4c-5d6e-7f8a9b0c1d2e",
  LIVESTOCK_SALE_NAME: "c9d0e1f2-a3b4-4c5d-6e7f-8a9b0c1d2e3f",
  LIVESTOCK_SALE_CODE: "d0e1f2a3-b4c5-4d6e-7f8a-9b0c1d2e3f4a",
  LIVESTOCK_SALE_DATE: "5a14e438-5351-405a-8192-77b8d036dfc0",
  QUANTITY: "e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b",
  QUANTITY_DELIVERED: "f2a3b4c5-d6e7-4f8a-9b0c-1d2e3f4a5b6c",
  SALE_LOT_STATUS: "a3b4c5d6-e7f8-4a9b-0c1d-2e3f4a5b6c7d",
  TRANSPORTER_NAME: "b4c5d6e7-f8a9-4b0c-1d2e-3f4a5b6c7d8e",
  THIRD_PARTY: "c5d6e7f8-a9b0-4c1d-2e3f-4a5b6c7d8e9f",
  AVERAGE_GRAMS: "d6e7f8a9-b0c1-4d2e-3f4a-5b6c7d8e9f0a",
  QUANTITY_WEIGHED: "e7f8a9b0-c1d2-4e3f-4a5b-6c7d8e9f0a1b",
  TOTAL_MASS_GRAMS: "f8a9b0c1-d2e3-4f4a-5b6c-7d8e9f0a1b2c",
  SPECIES: "a9b0c1d2-e3f4-4b5c-6d7e-8f0a1b2c3d4e",
  AGE: "b0c1d2e3-f4a5-4b6c-7d8e-9f0a1b2c3d4e",
  BREED: "c1d2e3f4-a5b6-4c7d-8e9f-0a1b2c3d4e5f",
  SEX: "d2e3f4a5-b6c7-4d8e-9f0a-1b2c3d4e5f6a",
  SALE_ROUND: "e3f4a5b6-c7d8-4e9f-0a1b-2c3d4e5f6a7b",
  MARKS: "f4a5b6c7-d8e9-4f0a-1b2c-3d4e5f6a7b8c",
  PROGENY: "1e0331b6-7eb0-4f4f-8102-8943061396de",
  SALEYARD_NAME: "dd440134-3489-49dc-8235-a83ad885abce",
};

export const Column = {
  ABN: "ABN",
  AGENCY_NAME: "livestockAgency.name",
  AGENCY_VENDOR_NUM: "consignment.agencyVendorNumber",
  AGE_GROUP_NAME: "age_group_name",
  BRANDS: "040e8d7e-8dd0-4e15-ad4f-678eeba8e2c7",
  IS_ANGUS_VERIFIED: "isAngusVerified",
  NOT_ANGUS_VERIFIED_COUNT: "notAngusVerifiedCount",
  ATTACHMENTS: "attachments",
  AVERAGE_WEIGHT: "averageWeightFormatted",
  AVERAGE_WEIGHT_OUTLIER: "averageWeightFormattedOutlier",
  BIDDER_REGO_NUMBER: "bidder.registrationNumber",
  BRANCH: "branchName",
  BUYER_ALTERNATIVES: "buyer.alternatives",
  BREED_NAME: "breed_name",
  BUYER_NAME: "buyer_name",
  BUYER_PAYMENTS: "buyerPaymentCount",
  BUSINESS_DISPLAY_NAME: "vendor.publicDisplayName",
  BUYER_WAY_NAME: "buyer_way_name",
  BUYER_SHORT_CODE: "buyer_short_code",
  BUYER_SHORT_CODE_SALEYARD: "buyer.shortCodeSaleyard",
  CARRIER: "carrierCharge.carrier",
  CATEGORY_NAME: "category_name",
  COMMENTS: CommentColId.COMMENTS,
  CREATED: "created",
  CURRENT_PIC: "current_pic",
  CONSIGNED_FROM: "consignedFrom",
  DELIVERY_DATE: "carrierCharge.deliveryDate",
  DELIVERY_PEN: "deliveryPen",
  DESTINATION_PIC: "destinationProperty.PIC",
  DIFF: "diff",
  DRAFT_DEVICE: "draft_device",
  DRAFT_NAME: "draft_name",
  EID: "EID",
  EU_STATUS: "EU_status",
  EXEMPTION_REASON: "exemption_name",
  GRADE_NAME: "grade_name",
  GST_STATUS: "gstStatus",
  HAS_EXCEPTIONS: "hasExceptions",
  IS_NLIS_SIGHTED: "is_nlis_sighted",
  IMAGES: "images",
  INVOICE_TO_CODE: "invoiceToCode",
  INVOICE_TO_NAME: "invoiceToName",
  IS_SELLABLE: "isSellable",
  IS_TRANSFERRED: "isTransferred",
  IS_TAKEABLE: "isTakeable",
  XERO_VENDOR: "xeroVendor",
  XERO_VENDOR_NAME: "xeroVendor.name",
  XERO_BUYER: "xeroBuyer",
  XERO_BUYER_NAME: "xeroBuyer.name",
  XERO_TARGET: "xeroTarget",
  LABELS: "labels",
  LAST_MODIFIED: "last_modified",
  LIFETIME_TRACEABILITY: "lifetime_traceability",
  LOT_NUMBER: "lot_number",
  LOT_NUMBER_COMBINED: "lotNumberCombined",
  LOT_NUMBER_SUFFIX: "lotNumberSuffix",
  LPA_STATUS: "lpaStatus",
  MARKS: "marks",
  NLIS_ID: "nlis_id",
  NLIS_TAKE_ID: "latestTakeFileTransactionId",
  NLIS_SELL_ID: "latestSellFileTransactionId",
  NLIS_TAKE_STATUS: "scan.nlis_take_status",
  NLIS_SELL_STATUS: "scan.nlis_sell_status",
  NLIS_TAKE_TRANSFER_STATUS: "latestTakeTransfer.response_type",
  NLIS_TAKE_TRANSFER_MESSAGE: "latestTakeTransfer.message_no",
  NLIS_TAKE_TRANSFER_NVD: "latestTakeTransfer.NVD",
  NLIS_TAKE_TRANSFER_VENDOR_PIC: "latestTakeTransfer.vendor_pic",
  NLIS_SELL_TRANSFER_BUYER_PIC: "latestSellTransfer.buyer_pic",
  NLIS_SELL_TRANSFER_STATUS: "latestSellTransfer.response_type",
  NLIS_SELL_TRANSFER_MESSAGE: "latestSellTransfer.message_no",
  NOMINATION: "nomination",
  NOMINATION_HC: "nominationHd",
  NOMINATION_CONSIGNING_DEPLOYMENT: "nominationConsigningDeployment.name",
  NOMINATION_DETAILS: "nominationDetails",
  NOMINATION_VENDOR: "nominationVendor.name",
  NOMINATION_HAS_ARRIVED: "nomination.hasArrived",
  NOMINATION_GRAND_TOTAL: "nomination.grandTotal",
  NOMINATION_CONSIGNMENT_DIFF: "nomination.consignmentDiff",
  NOTE: "note",
  NVD: "consignment.NVD",
  NVD_ID: "NVD",
  OVERFLOW_PEN: "overflowPen",
  OPEN_AUCTION_COUNT: "openAuctionCount",
  PEN: "penName",
  PIC_PROGRAMS: "nlisPrograms",
  QUANTITY: "quantity",
  QUANTITY_DELIVERED: "quantity_delivered",
  QUANTITY_PROGENY: "quantityProgeny",
  QUANTITY_TAGS_USED: "quantityTagsUsed",
  PRICING_TYPE: "pricing_type_id",
  AGENT_RELATIONSHIP: "vendor.relationships",
  STATUS: "status",
  SALE_ROUND_NAME: "sale_round_name",
  SEX_NAME: "sex_name",
  SCAN_ERP_STATUS: "ERP_status",
  SCANNED_COUNT: "scannedCount",
  SCANNED_PERCENTAGE: "scannedPercentage",
  SCANNED_PERCENTAGE_FORMATTED: "scannedPercentageFormatted",
  SINGLE_WEIGH_SUM: "totalSingleWeighedWeight",
  SINGLE_WEIGH_DIFF: "totalSingleWeighedWeightDiff",
  SINGLE_WEIGH_SUM_OUTLIER: "totalSingleWeighedWeightOutlier",
  TOTALS: "totals",
  TARGET_BUSINESS_NAME: "targetBusiness.name",
  TIME_BULK_WEIGHED: "bulkWeighTime",
  SCAN_TIME_WEIGHED: "time_weighed",
  THIRD_PARTY_NAME: "thirdPartyName",
  TOTAL_PRICE: "total_price_cents",
  UNIT_PRICE: "unit_price",
  UNIT_PRICE_FORMATTED: "unitPriceFormatted",
  VENDOR_ALTERNATIVES: "vendor.alternatives",
  VENDOR_NAME: "vendor_name",
  VENDOR_PIC: "consignment.vendor_property.PIC",
  VENDOR_NUM: "vendorNumber",
  VENDOR_SHORT_CODE: "vendor_short_code",
  VENDOR_SHORT_CODE_SALEYARD: "vendor.shortCodeSaleyard",
  WEIGHED_COUNT: "weighedCount",
  WEIGHT: "totalWeightFormatted",
  WEIGHT_OUTLIER: "totalWeightOutlier",

  // The following are not in alphabetical order
  TOTAL_MASS_GRAMS: "totalMassGrams",
  TOTAL_MASS_GRAMS_OUTLIER: "totalMassGramsOutlier",
  IS_MANUALLY_WEIGHED: "a883f41d-21b1-42e0-afd6-e9e482a71b31",
  BUYER_NUMBER: "buyerNumber",
  IS_GST_EXEMPT: "isGSTExempt",
  ITEM_LOCATION: "itemLocation",
  HAS_PICKUP_ADDRESS: "hasPickupAddress",
  HAS_BUYER_POSTAL_ADDRESS: "hasBuyerPostalAddress",
  HAS_VENDOR_POSTAL_ADDRESS: "hasVendorPostalAddress",

  VENDOR_COMMISSION: "vendorCommission",
  LISTING_FEE: "listingFee",
  BUYERS_PREMIUM: "buyersPremium",

  EFFECTIVE_VENDOR_COMMISSION_PERCENT: "effectiveVendorCommissionPercent",
  EFFECTIVE_VENDOR_COMMISSION_CENTS: "effectiveVendorCommissionCents",
  EFFECTIVE_LISTING_FEE_CENTS: "effectiveListingFeeCents",
  EFFECTIVE_BUYERS_PREMIUM_PERCENT: "effectiveBuyersPremiumPercent",
  EFFECTIVE_BUYERS_PREMIUM_CENTS: "effectiveBuyersPremiumCents",

  RESERVE_PRICE: "reservePrice",
  STARTING_BID: "startingBid",
  BID_INCREMENT: "bidIncrement",
  ORIGINAL_LISTING_PRICE: "originalListingPrice",

  CLEARING_SALE_CATEGORY: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "category",
  ),
  CLEARING_SALE_COMMENTS: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "comments",
  ),
  CLEARING_SALE_HOURS: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "hours",
  ),
  CLEARING_SALE_INSPECTION: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "inspection",
  ),
  CLEARING_SALE_ITEM_CONDITION: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "itemCondition",
  ),
  CLEARING_SALE_ITEM_TYPE: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "itemType",
  ),
  CLEARING_SALE_MAKE: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "make",
  ),
  CLEARING_SALE_MODEL: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "model",
  ),
  CLEARING_SALE_NEW_USED: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "newUsed",
  ),
  CLEARING_SALE_ODOMETER: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "odometer",
  ),
  CLEARING_SALE_PPSR_COMMENTS: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "ppsrComments",
  ),
  CLEARING_SALE_PPSR_STATUS: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "ppsrStatus",
  ),
  CLEARING_SALE_PUBLIC_DESCRIPTION: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "publicDescription",
  ),
  CLEARING_SALE_REGISTRATION: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "registration",
  ),
  CLEARING_SALE_SELL_SAFE_CATEGORY: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "sellSafeCategory",
  ),
  CLEARING_SALE_STATUS: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "status",
  ),
  CLEARING_SALE_SUB_TYPE: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "subType",
  ),
  CLEARING_SALE_TITLE: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "title",
  ),
  CLEARING_SALE_VIN: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "vin",
  ),
  CLEARING_SALE_YEAR: withNamespace(
    SaleLotNamespaces.CLEARING_SALE_ATTRIBUTES,
    "year",
  ),
  LISTING_ID: "listingId",
  SALEYARD_NAME: "3c8a292f-8759-4f79-a76a-d9f5949e4bc3",
  XERO,
  LivestockSaleColId,
  Consignment: ConsignmentColId,
  DraftingAttributes: DraftingAttributesColId,
  SaleLot: SaleLotColId,
  BillingTags: BillingTagsColId,
  Issuer: IssuerColId,
  Recipient: RecipientColId,
  RuleBook: RuleBookColId,
  Email: EmailColId,
  Totals: TotalColId,
  Transporter: TransporterColId,
  Loads: LoadsColId,
};

export const LivestockSaleColumnDisplayName = {
  [LivestockSaleColId.TITLE]: "Livestock Sale",
};

export const ColumnDisplayName = {
  [Column.AGE_GROUP_NAME]: "Age",
  [Column.NOT_ANGUS_VERIFIED_COUNT]: "Not Angus Verified Count",
  [Column.AVERAGE_WEIGHT]: "Avg. Wt.",
  [Column.AVERAGE_WEIGHT_OUTLIER]: "In Range?",
  [Column.BID_INCREMENT]: "Bid Inc",
  [Column.BIDDER_REGO_NUMBER]: "Bidder #",
  [Column.BREED_NAME]: "Breed",
  [Column.BUYER_NAME]: "Buyer Name",
  [Column.BUYER_NUMBER]: "Buyer #",
  [Column.BUYER_PAYMENTS]: "Buyer Payments",
  [Column.BUYER_SHORT_CODE_SALEYARD]: "SY Ref",
  [Column.BUYER_SHORT_CODE]: "Agent Ref",
  [Column.BUYER_WAY_NAME]: "Buyer Way",
  [Column.CARRIER]: "Carrier",
  [Column.CATEGORY_NAME]: "Category",
  [Column.CLEARING_SALE_CATEGORY]: "Category",
  [Column.CLEARING_SALE_COMMENTS]: "Comments",
  [Column.CLEARING_SALE_HOURS]: "Hours",
  [Column.CLEARING_SALE_INSPECTION]: "Inspection",
  [Column.CLEARING_SALE_ITEM_CONDITION]: "Condition",
  [Column.CLEARING_SALE_ITEM_TYPE]: "Type",
  [Column.CLEARING_SALE_MAKE]: "Make",
  [Column.CLEARING_SALE_MODEL]: "Model",
  [Column.CLEARING_SALE_NEW_USED]: "New/Used",
  [Column.CLEARING_SALE_ODOMETER]: "Odometer",
  [Column.CLEARING_SALE_PPSR_COMMENTS]: "PPSR Comments",
  [Column.CLEARING_SALE_PPSR_STATUS]: "PPSR Status",
  [Column.CLEARING_SALE_PUBLIC_DESCRIPTION]: "Public Description",
  [Column.CLEARING_SALE_REGISTRATION]: "Registration",
  [Column.CLEARING_SALE_SELL_SAFE_CATEGORY]: "Sell Safe",
  [Column.CLEARING_SALE_STATUS]: "Status",
  [Column.CLEARING_SALE_SUB_TYPE]: "Sub Type",
  [Column.CLEARING_SALE_TITLE]: "Title",
  [Column.CLEARING_SALE_VIN]: "VIN",
  [Column.CLEARING_SALE_YEAR]: "Year",
  [Column.LISTING_ID]: "Listing ID",
  [Column.CONSIGNED_FROM]: "Consigned From",
  [Column.CURRENT_PIC]: "Current PIC",
  [Column.DELIVERY_PEN]: "Delivery Pen",
  [Column.DESTINATION_PIC]: "Buyer PIC",
  [Column.DIFF]: "Diff",
  [Column.DRAFT_DEVICE]: "Draft Device",
  [Column.DRAFT_NAME]: "Draft Name",
  [Column.EFFECTIVE_BUYERS_PREMIUM_CENTS]: "B Prem",
  [Column.EFFECTIVE_BUYERS_PREMIUM_PERCENT]: "B Prem %",
  [Column.EFFECTIVE_LISTING_FEE_CENTS]: "List Fee",
  [Column.EFFECTIVE_VENDOR_COMMISSION_CENTS]: "Vendor Comm.",
  [Column.EFFECTIVE_VENDOR_COMMISSION_PERCENT]: "Vendor Comm. %",
  [Column.EXEMPTION_REASON]: "Exemption Reason",
  [Column.GRADE_NAME]: "Grade",
  [Column.HAS_BUYER_POSTAL_ADDRESS]: "Buyer Addr.",
  [Column.HAS_EXCEPTIONS]: "Has Exceptions",
  [Column.HAS_PICKUP_ADDRESS]: "Pickup Addr.",
  [Column.HAS_VENDOR_POSTAL_ADDRESS]: "Vendor Addr.",
  [Column.XERO_VENDOR]: "Vendor (Xero)",
  [Column.XERO_VENDOR_NAME]: "Vendor Name (Xero)",
  [Column.XERO_BUYER]: "Buyer (Xero)",
  [Column.XERO_BUYER_NAME]: "Buyer Name (Xero)",
  [Column.IMAGES]: "Images",
  [Column.IS_GST_EXEMPT]: "GST Exempt",
  [Column.IS_SELLABLE]: "Is Sellable",
  [Column.IS_TAKEABLE]: "Is Takeable",
  [Column.ITEM_LOCATION]: "Item Location",
  [Column.LABELS]: "Labels",
  [Column.LOT_NUMBER]: "Lot",
  [Column.LOT_NUMBER_SUFFIX]: "Lot# Suffix",
  [Column.LOT_NUMBER_COMBINED]: "Lot#",
  [Column.MARKS]: "Marks",
  [Column.NLIS_SELL_ID]: "NLIS Sell ID",
  [Column.NLIS_SELL_STATUS]: "NLIS Sell Status",
  [Column.NLIS_TAKE_ID]: "NLIS Take ID",
  [Column.NLIS_TAKE_STATUS]: "NLIS Take Status",
  [Column.NOTE]: "Note",
  [Column.NOMINATION]: "Nomination",
  [Column.NOMINATION_HC]: "Nominated Hd",
  [Column.NOMINATION_CONSIGNING_DEPLOYMENT]: "Consigning Deployment",
  [Column.NOMINATION_DETAILS]: "Nomination Ref",
  [Column.NOMINATION_VENDOR]: "Vendor",
  [Column.NOMINATION_HAS_ARRIVED]: "Has Arrived",
  [Column.NVD]: "NVD",
  [Column.OPEN_AUCTION_COUNT]: "OA",
  [Column.OVERFLOW_PEN]: "Overflow Pen",
  [Column.ORIGINAL_LISTING_PRICE]: "Original Price",
  [Column.PEN]: "Pen",
  [Column.PRICING_TYPE]: "Pricing Type",
  [Column.QUANTITY_DELIVERED]: "Delivered",
  [Column.QUANTITY_PROGENY]: "Progeny",
  [Column.RESERVE_PRICE]: "Res Price",
  [Column.AGENT_RELATIONSHIP]: "Agent",
  [Column.SALE_ROUND_NAME]: "Sale Round",
  [Column.SEX_NAME]: "Sex",
  [Column.SINGLE_WEIGH_SUM]: "Single Weigh Sum",
  [Column.SINGLE_WEIGH_DIFF]: "Single Weigh Diff",
  [Column.SINGLE_WEIGH_SUM_OUTLIER]: "In Range?",
  [Column.STARTING_BID]: "Start Bid",
  [Column.STATUS]: "Status",
  [Column.THIRD_PARTY_NAME]: "Third Party",
  [Column.TIME_BULK_WEIGHED]: "Bulk Weigh Time",
  [Column.TOTALS]: "Totals",
  [Column.TOTAL_PRICE]: "Total Price",
  [Column.UNIT_PRICE]: "Unit Price",
  [Column.VENDOR_PIC]: "Vendor PIC",
  [Column.WEIGHED_COUNT]: "Weighed",
  [Column.WEIGHT]: "Tot. Wt.",
  [Column.WEIGHT_OUTLIER]: "In Range?",
};

export const LIVESTOCK_AGENT_COLUMNS_BLACKLIST = [Column.AGENCY_NAME];
